<div
  class="fixed inset-0 bg-black/40 flex items-center justify-center z-[9999]"
>
  <div
    class="bg-white rounded-xl shadow-xl w-[90%] max-w-md p-4 animate-fadeIn"
  >
    <div class="flex items-start justify-start mb-2">
        <lucide-angular color="#3681B2" size="20" [img]="BellRing"></lucide-angular>
    </div>

    <h2 *ngIf="title" class="text-lg font-medium text-neutral-600 mb-2">
      {{ title }}
    </h2>

    <p *ngIf="body" class="text-neutral-600 text-base mb-3 font-normal">
      {{ body }}
    </p>

    <div class="flex justify-center">
      <button
        (click)="onClose()"
        class="bg-brand-700 text-white px-4 py-3 rounded-md text-sm font-normal"
      >
        Verstanden
      </button>
    </div>
  </div>
</div>
